<template>
  <div class="flex gap-2 flex-row">
    <div v-for="(item, status) of statusCounts" :key="status" >
      <div v-if="item.count > 0" class="group">
        <div
          class="peer flex items-center gap-2 rounded-full border border-neutral-100 bg-neutral-100 px-2 py-1 hover:border-primary-300"
        >
          <span class="peer h-3 w-3 rounded-full" :class="iconBackground(status)"></span>
          <span class="font-medium text-black">{{ item.count }}</span>
        </div>
        <div
          class="pointer-events-none absolute -bottom-10 left-1/2 z-[1] -translate-x-1/2 rounded-md bg-black px-2 py-1 text-sm text-white opacity-0 transition"
        >
          {{
            t(
              `chargingStation.evse.${item.name
                .replace(/\beV([a-zA-Z]+)/g, (_: string, word: string) => word)
                .toUpperCase()}`
            )
          }}
          <div
            class="absolute bottom-full left-1/2 h-0 w-0 -translate-x-1/2 border-x-8 border-b-8 border-x-transparent border-b-black"
          ></div>
        </div>
      </div>

    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { StatusColors } from './types/StatusVisuals';
import { useI18n } from 'vue-i18n';
import {ChargingStation} from "@infuse/cpms/charging-station/store";

interface Props {
  chargingStation: ChargingStation;
}

const { t } = useI18n();

const props = withDefaults(defineProps<Props>(), {});


const statusCounts = computed(() => {
  const eVStatusRecord: Record<string, { name: string; count: number }> = {
    eVavailable: {name: "AVAILABLE", count: 0},
    eVcharging: {name: "OCCUPIED", count: 0},
    eVerror: {name: "FAULTED", count: 0},
    warning: {name: "INOPERATIVE", count: 0},
    eVinactive: {name: "UNKNOWN", count: 0},
    neutral: {name: "OFFLINE", count: 0},
  };

  if(!props.chargingStation.evses || props.chargingStation.evses.length === 0) {
    return eVStatusRecord;
  }
  for (const evse of props.chargingStation.evses) {
    for (const connector of evse.connectors) {
      const colorKey = connector.status && StatusColors[connector.status.toUpperCase()];
      if (colorKey && eVStatusRecord[colorKey]) {
        eVStatusRecord[colorKey].count = (eVStatusRecord[colorKey].count || 0) + 1;
      }
    }
  }

  const filteredStatusRecord: Record<string,  { name: string; count: number }> = Object.fromEntries(
    Object.entries(eVStatusRecord).filter(([_, value]) => value.count !== 0)
  );
  return filteredStatusRecord;
});



const iconBackground = (chargingStationsStatus: string) => {
  return `bg-${chargingStationsStatus}-500`;
};
</script>
